import ngeohash from 'ngeohash';
/**
 * Compute geohash for a latitude/longitude coordinate
 * @param lat Latitude
 * @param lng Longitude
 * @param precision Geohash precision (default 4 for ~20km x 20km tiles)
 * @returns Geohash string
 */
export function computeGeohash(lat, lng, precision = 4) {
    return ngeohash.encode(lat, lng, precision);
}
/**
 * Get the 8 neighboring geohashes for a given geohash
 * @param geohash The center geohash
 * @returns Array of 8 neighboring geohashes
 */
export function getNeighborGeohashes(geohash) {
    const neighbors = ngeohash.neighbors(geohash);
    // ngeohash.neighbors returns an array in order: [n, ne, e, se, s, sw, w, nw]
    return neighbors;
}
/**
 * Get all 9 tile geohashes (center + 8 neighbors) for a location
 * @param lat Latitude
 * @param lng Longitude
 * @returns Array of 9 geohashes (center first, then 8 neighbors)
 */
export function getAllTileGeohashes(lat, lng) {
    const center = computeGeohash(lat, lng);
    const neighbors = getNeighborGeohashes(center);
    return [center, ...neighbors];
}
